import "../index.css";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import { baseURL } from "../baseURL";
import React, { useState } from "react";
import axios from "axios";

const EmbeddedFormScorecardSubscribePage = ({ onSuccess, onError }) => {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitSubscribeForm = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/api/submit-subscribe-form`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          role: "",
          organization: "",
          zip: "",
          message: "",
          subscribe: false,
          pilotInterest: false,
        });
        onSuccess("subscribe");
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmitSubscribeForm}>
        <p>
          Providing your contact information enables us to share best practices,
          communicate updates, and network with our global wildfire prevention
          community.
        </p>
        <div className="form-group">
          <label>*First Name</label>
          <input
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>*Last Name</label>
          <input
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>*Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Organization</label>
          <input
            name="organization"
            value={formData.organization}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Role</label>
          <input name="role" value={formData.role} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>*Zip/Postal Code</label>
          <input
            name="zip"
            value={formData.zip}
            onChange={handleChange}
            required
          />
        </div>

        <div className="checkbox-group">
          <label>
            <input
              type="checkbox"
              name="subscribe"
              checked={formData.subscribe}
              onChange={handleChange}
            />
            Subscribe
          </label>
        </div>

        <div className="checkbox-group">
          <label>
            <input
              type="checkbox"
              name="pilotInterest"
              checked={formData.pilotInterest}
              onChange={handleChange}
            />
            I'm interested in piloting with CWPC
          </label>
        </div>

        <div className="form-group">
          <label>Message:</label>
          <textarea
            name="message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
          />
        </div>
        <PolicyContainer text="Subscribe" />
        <Button color="var(--green)" text="Subscribe" />
      </form>
    </>
  );
};

export default EmbeddedFormScorecardSubscribePage;
